const onboardingSteps = {
  0: {
    name: "Choose a plan",
    visible: true,
  },
  1: {
    name: "Create a WhatsApp account",
    visible: true,
  },
  2: {
    name: "Add a WhatsApp payment method",
    visible: true,
  },
  // Profile picture + certification
  3: {
    name: "Complete your WhatsApp profile",
    visible: true,
  },
  4: {
    name: "Try sending/receiving messages",
    visible: true,
  },
  5: {
    // Connect Shopify and/or Klaviyo or import csv
    name: "Synchronize your contacts",
    visible: true,
  },
  8: {
    // QTrack
    name: "Synchronize purchase intents",
    visible: true,
  },
  6: {
    // Connect Crisp/Gorgias/Zendesk or email notifications
    name: "Notify your customer service",
    visible: true,
  },
  7: {
    // Add Shopify checkout checkbox and/or Klaviyo 2-step popup or on your website
    name: "Start collecting new optins",
    visible: true,
  },
};

export default onboardingSteps;
